__turbopack_context__.v({
  "box": "ProducerSimulationBox-module-scss-module__WTSKDG__box",
  "choose-different-btn": "ProducerSimulationBox-module-scss-module__WTSKDG__choose-different-btn",
  "cta": "ProducerSimulationBox-module-scss-module__WTSKDG__cta",
  "highlighted": "ProducerSimulationBox-module-scss-module__WTSKDG__highlighted",
  "sticky": "ProducerSimulationBox-module-scss-module__WTSKDG__sticky",
});
